import { gql } from '@apollo/client';

const updateBookingAccount = gql`
  mutation ($variables: BookingAccountUpdate!, $id: Int!) {
    updateBookingAccount(input: $variables, id: $id)
  }
`;
export default updateBookingAccount;
